function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_btc)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 84.8148,
  cy: 16.1849,
  r: 14.1849,
  fill: "url(#paint0_linear_btc)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.4353 9.50507H84.8388C88.1255 9.50507 90.6169 11.2717 91.5438 13.8423H93.227V15.3961H91.8983C91.9243 15.6416 91.9376 15.8917 91.9376 16.1459V16.184C91.9376 16.4702 91.9208 16.7514 91.8879 17.0269H93.227V18.5807H91.5118C90.5605 21.1155 88.0884 22.8653 84.8388 22.8653H79.4353V18.5807H77.5576V17.0269H79.4353V15.3961H77.5576V13.8423H79.4353V9.50507ZM80.9459 18.5807V21.4715H84.8388C87.241 21.4715 89.0258 20.3137 89.8566 18.5807H80.9459ZM90.3194 17.0269H80.9459V15.3961H90.3218C90.3566 15.6527 90.3743 15.9158 90.3743 16.184V16.2222C90.3743 16.4966 90.3557 16.7653 90.3194 17.0269ZM84.8388 10.8966C87.2521 10.8966 89.0422 12.085 89.868 13.8423H80.9459V10.8966H84.8388Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_btc)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.9453 19.6185C28.0505 27.2185 20.353 31.8437 12.7522 29.9485C5.15447 28.0537 0.529246 20.3558 2.42491 12.7563C4.3188 5.15542 12.0163 0.529749 19.6149 2.42453C27.2153 4.31931 31.8401 12.0181 29.9453 19.6185Z",
  fill: "#F7931A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4374 14.1654C22.7198 12.2777 21.2825 11.2629 19.3173 10.5859L19.9548 8.02882L18.3983 7.64091L17.7776 10.1306C17.3684 10.0287 16.9481 9.93247 16.5305 9.83715L17.1556 7.33103L15.6 6.94312L14.962 9.49934C14.6233 9.4222 14.2908 9.34595 13.9681 9.26571L13.9699 9.25772L11.8233 8.72174L11.4092 10.3842C11.4092 10.3842 12.5641 10.6489 12.5397 10.6653C13.1701 10.8227 13.284 11.2398 13.265 11.5706L12.5388 14.4837C12.5823 14.4947 12.6386 14.5107 12.7006 14.5355C12.6488 14.5227 12.5933 14.5085 12.5362 14.4947L11.5183 18.5756C11.4411 18.7671 11.2456 19.0544 10.805 18.9453C10.8205 18.9679 9.6736 18.6629 9.6736 18.6629L8.90088 20.4446L10.9264 20.9496C11.3033 21.044 11.6726 21.1429 12.0361 21.236L11.3919 23.8223L12.9467 24.2103L13.5846 21.6514C14.0093 21.7666 14.4216 21.873 14.8251 21.9732L14.1893 24.5201L15.7458 24.908L16.39 22.3266C19.0442 22.8288 21.04 22.6262 21.8802 20.2256C22.5571 18.2927 21.8465 17.1778 20.45 16.4507C21.467 16.2162 22.233 15.5472 22.4374 14.1654ZM18.881 19.1523C18.4 21.0852 15.1456 20.0403 14.0905 19.7783L14.9452 16.3518C16.0003 16.6152 19.3838 17.1365 18.881 19.1523ZM19.3625 14.1374C18.9236 15.8957 16.2149 15.0024 15.3362 14.7834L16.1111 11.6756C16.9898 11.8946 19.8196 12.3034 19.3625 14.1374Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.959 11.4501C63.072 11.3667 63.072 11.1977 62.959 11.1144L60.7028 9.44996C60.5651 9.34836 60.3704 9.44668 60.3704 9.61782V12.9467C60.3704 13.1178 60.5651 13.2161 60.7028 13.1145L62.959 11.4501ZM45.038 11.3869C45.038 11.8477 44.6644 12.2213 44.2035 12.2213C43.7427 12.2213 43.3691 11.8477 43.3691 11.3869C43.3691 10.9261 43.7427 10.5525 44.2035 10.5525C44.6644 10.5525 45.038 10.9261 45.038 11.3869ZM49.21 11.3869C49.21 11.8477 48.8364 12.2213 48.3755 12.2213C47.9147 12.2213 47.5411 11.8477 47.5411 11.3869C47.5411 10.9261 47.9147 10.5525 48.3755 10.5525C48.8364 10.5525 49.21 10.9261 49.21 11.3869ZM52.5475 12.2213C53.0084 12.2213 53.3819 11.8477 53.3819 11.3869C53.3819 10.9261 53.0084 10.5525 52.5475 10.5525C52.0867 10.5525 51.7131 10.9261 51.7131 11.3869C51.7131 11.8477 52.0867 12.2213 52.5475 12.2213ZM57.5539 11.3869C57.5539 11.8477 57.1804 12.2213 56.7195 12.2213C56.2587 12.2213 55.8851 11.8477 55.8851 11.3869C55.8851 10.9261 56.2587 10.5525 56.7195 10.5525C57.1804 10.5525 57.5539 10.9261 57.5539 11.3869Z",
  fill: "#231536"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.9639 21.0461C37.8509 20.9628 37.8509 20.7938 37.9639 20.7104L40.22 19.046C40.3578 18.9444 40.5525 19.0427 40.5525 19.2139V22.5427C40.5525 22.7138 40.3578 22.8122 40.22 22.7106L37.9639 21.0461ZM55.8849 20.9829C55.8849 21.4438 56.2585 21.8173 56.7193 21.8173C57.1801 21.8173 57.5537 21.4438 57.5537 20.9829C57.5537 20.5221 57.1801 20.1485 56.7193 20.1485C56.2585 20.1485 55.8849 20.5221 55.8849 20.9829ZM51.7129 20.9829C51.7129 21.4438 52.0865 21.8173 52.5473 21.8173C53.0081 21.8173 53.3817 21.4438 53.3817 20.9829C53.3817 20.5221 53.0081 20.1485 52.5473 20.1485C52.0865 20.1485 51.7129 20.5221 51.7129 20.9829ZM48.3753 21.8173C47.9145 21.8173 47.5409 21.4438 47.5409 20.9829C47.5409 20.5221 47.9145 20.1485 48.3753 20.1485C48.8361 20.1485 49.2097 20.5221 49.2097 20.9829C49.2097 21.4438 48.8361 21.8173 48.3753 21.8173ZM43.3689 20.9829C43.3689 21.4438 43.7425 21.8173 44.2033 21.8173C44.6642 21.8173 45.0377 21.4438 45.0377 20.9829C45.0377 20.5221 44.6642 20.1485 44.2033 20.1485C43.7425 20.1485 43.3689 20.5221 43.3689 20.9829Z",
  fill: "#231536"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_btc",
  x: 68.9611,
  y: 0.748387,
  width: 31.7075,
  height: 31.7075,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.417204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.834409
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_btc",
  x: 0.331183,
  y: 0.748387,
  width: 31.7075,
  height: 31.7108,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.417204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.834409
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_btc",
  x1: 84.8148,
  y1: -2.01907,
  x2: 84.8148,
  y2: 33.3487,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBCC5F"
})));

var SvgBtcToDai = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 33,
    viewBox: "0 0 101 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBtcToDai, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/btc-to-dai.4bd0e5d7.svg";
export { ForwardRef as ReactComponent };